import { Component } from '@angular/core'
import { NgForm, FormsModule } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { BaseComponent, Services } from '../../shared'
import { CookieService } from 'ngx-cookie-service'
import { NgIf } from '@angular/common'

@Component({
    templateUrl: './site-visitor.component.html',
    styleUrls: ['./site-visitor.component.css'],
    standalone: true,
    imports: [FormsModule, NgIf],
})
export class SiteVisitorComponent extends BaseComponent {
    faSpinner = faSpinner
    visitor = {} as any
    visitorLogged = false
    visitorFirstName = ''
    welcomeText = 'Welcome Visitor!'
    jobs: any[] = []
    job!: any

    constructor(
        services: Services,
        private route: ActivatedRoute,
        private cookieService: CookieService,
    ) {
        super()
        this.refresh()
    }

    refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data.load(true, true, this.services.data.vpJobs.queryAll()).subscribe(
                successResult => {
                    this.initialLoadingComplete()
                    this.jobs = successResult[0].orderByDescending(x => x.id)

                    const queryParams = this.route.snapshot.queryParams
                    console.log('Query Params:', queryParams)

                    const job = queryParams['job']
                    if (job) {
                        this.job = this.jobs.find(x => x.id.indexOf(job) > -1)
                        console.log(this.job)
                    }
                    if (this.job) {
                        this.welcomeText = 'Welcome to ' + this.job.name + '!'
                    }

                    var visitorFirstName = this.cookieService.get('visitorName')
                    if (visitorFirstName) {
                        this.welcomeText = 'Welcome ' + visitorFirstName + ' to ' + this.job.name + '!'
                        this.visitorFirstName = visitorFirstName
                        this.visitorLogged = true
                    }
                },
                errorResult => {},
            ),
        )
    }
    submitForm(form: NgForm) {
        let soon = new Date().addMinutes(1)
        this.cookieService.set('visitorName', this.visitor.firstName, soon)
        var blah = this.cookieService.get('visitorName')
        console.log(blah)
        this.visitorFirstName = this.visitor.firstName
        this.visitorLogged = true
        this.welcomeText = 'Welcome ' + this.visitorFirstName + ' to ' + this.job.name + '!'
    }
}
